module.exports = __webpack_public_path__ + "cn.svg?b69b626264f1942426aa4874a2a9c70a";